<template>
  <span v-if="value.released_at">{{
    new Date(value.released_at).toLocaleDateString()
  }}</span>
</template>

<script setup>
defineProps({
  value: {
    required: true,
    type: Object
  }
})
</script>
